// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b5803e19","703":"fbd86e03","787":"2303afe7"}[chunkId] + ".chunk.js";
};